import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      "bg-[url('/images/bg.svg')] bg-cover bg-center",
      className
    )}
  />
);
